<template>
    <div>
        <div class="flex mt-[42px] mb-[27px] justify-between h-[42px]">
            <h1
                class="text-[21px] font-medium leading-normal tracking-small text-gray-800"
            >
                {{ $t("vue.integrations") }}
            </h1>
        </div>
        <BasicTabs :tabs="tabs" :tab-key="tabKey">
            <slot />
            <IntegrationModals />
        </BasicTabs>
    </div>
</template>

<script lang="ts" setup>
import route from "ziggy-js";
import type TabItem from "@/types/Settings/TabItem";
import { RectangleStackIcon } from "@heroicons/vue/24/outline";
// import { CheckCircleIcon } from "@heroicons/vue/24/outline"; // used by Active tab when re-enabled
import { useTranslations } from "@/composables/useTranslations";

interface DataTableProps {
    tabKey: string;
}

withDefaults(defineProps<DataTableProps>(), {
    tabKey: "available",
});

const { t } = useTranslations();

const tabs: TabItem[] = [
    {
        title: t("vue.available"),
        key: "available",
        icon: RectangleStackIcon,
        url: route("integrations.available.index"),
    },
    // {
    //     title: t("vue.active"),
    //     key: "active",
    //     icon: CheckCircleIcon,
    //     url: route("integrations.index"),
    // },
];
</script>
